import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { take } from 'rxjs';
import { CaptchaV3ConfigModel } from '../../../../shared/models/start-up-config/captcha-v3-config';
import { StartUpConfigUiService } from '../../../../shared/service/ui/start-up-config-ui.service';
import { CookieService } from '../../../../shared/service/util/cookie.service';
import { CaptchaV3UiService } from '../../../service/captcha-v3-ui.service';

@Component({
  selector: 'ras-recaptchav3',
  templateUrl: './captcha-v3.component.html',
  styles: ['.grecaptcha-badge{ visibility:hidden; }'],
  encapsulation: ViewEncapsulation.None
})
export class CaptchaV3Component implements OnInit {
  private siteKey = '';
  private captchaSettings: CaptchaV3ConfigModel;

  constructor(
    private startUpConfigUiService: StartUpConfigUiService,
    private reCaptchaV3Service: CaptchaV3UiService,
    private cookieService: CookieService
  ) {}

  ngOnInit() {
    this.startUpConfigUiService.sessionInfo$.subscribe({
      next: (sessionInfo) => {
        if (!sessionInfo.isMobileApp) {
          this.startUpConfigUiService.deferredConfig$.pipe(take(1)).subscribe({
            next: (deferredConfig) => {
              this.captchaSettings = deferredConfig.captchaV3Settings;
              if (!this.captchaSettings) {
                return;
              }

              if (!this.captchaSettings.isEnabled) {
                return;
              }

              this.siteKey = this.captchaSettings.settings.siteKey;

              this.reCaptchaV3Service.init(this.siteKey, { action: 'homepage' }).then(() => {
                this.subscribeTokenProvider(sessionInfo.isWhiteLabel);
              });
            }
          });
        }
      }
    });
  }

  subscribeTokenProvider(isWL: boolean) {
    this.reCaptchaV3Service.CaptchaTokenSubject.pipe(take(1)).subscribe((token: any) => {
      // Get value from cookie to check if already stored for the same session
      const isNewSession = this.CheckIfNewSession(this.captchaSettings.settings.cookieKey);
      if (isNewSession) {
        // Set value to cookie to prevent the same session entry
        if (!isWL) {
          this.cookieService.set(this.captchaSettings.settings.cookieKey, 'true', 1, '', this.captchaSettings.settings.cookieDomain);
        } else {
          this.cookieService.set(this.captchaSettings.settings.cookieKey, 'true', 1, '', '', true, 'None');
        }

        this.VerifyTokenAndSaveScore(token);
        // this.reCaptchaV3Service.hideCaptcha();
      }
    });
  }

  getToken() {
    this.reCaptchaV3Service.getToken({ action: 'homepage' }).then((token) => {
      // Get value from cookie to check if already stored for the same session
      const isNewSession = this.CheckIfNewSession(this.captchaSettings.settings.cookieKey);
      if (isNewSession) {
        // Set value to cookie to prevent the same session entry
        this.cookieService.set(this.captchaSettings.settings.cookieKey, 'true', 1);

        this.VerifyTokenAndSaveScore(token);
        // this.reCaptchaV3Service.hideCaptcha();
      }
    });
  }

  VerifyTokenAndSaveScore(token: string) {
    // Get score with token and save
    this.reCaptchaV3Service
      .validateCaptchaToken(token)
      .pipe(take(1))
      .subscribe(
        () => {
          console.warn('captcha validated');
        },
        (err: any) => console.error('HTTP Error (VerifyTokenAndSaveScore): ', err)
      );
  }

  CheckIfNewSession(key: string): boolean {
    return this.cookieService.get(key) === 'false' || this.cookieService.get(key) === '' ? true : false;
  }
}
